module.exports = __webpack_public_path__ + "static/media/discoverProject.e450de4d.svg";